// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3pIak","requiredAsterisk":"Info_requiredAsterisk__1Eh9P"};